module.exports = function chebyshev(a, b) {
    var ii = a.length,
        max = 0,
        aux = 0;
    for (var i = 0; i < ii ; i++) {
        aux = Math.abs(a[i] - b[i]);
        if (max < aux) {
            max = aux;
        }
    }
    return max;
};



//////////////////
// WEBPACK FOOTER
// ./~/ml-distance/src/distances/chebyshev.js
// module id = 77
// module chunks = 0